import React from "react";
import T from "prop-types";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { ConfirmAction, Icon } from "MODULES/shared/components";
import { translateProps } from "MODULES/shared/decorators";
import api from "APP_ROOT/api";

function ReverseCancellation({ open, close, reverseCancellation }) {
  return (
    <ConfirmAction
      onConfirm={reverseCancellation}
      close={close}
      open={open}
      icon={<Icon name="undo" fixed />}
      btnText="Yes, Reverse Cancellation"
      title="Reverse Cancellation"
    >
      <strong>Heads up!</strong>
      &nbsp; This will reverse the cancellation of this Sales Order.
    </ConfirmAction>
  );
}

ReverseCancellation.propTypes = {
  close: T.func.isRequired,
  reverseCancellation: T.func.isRequired,
  open: T.bool
};

const withReverseCancellation = translateProps(
  ({ lineItem, salesOrder, refresh, expireLineItems, close }) => ({
    reverseCancellation: () =>
      api.salesOrders.lineItems.cancellationReversal(lineItem.id).then(() =>
        refresh(salesOrder.get("id")).then(() => {
          expireLineItems();
          close();
        })
      )
  })
);

export default withSalesOrder(withReverseCancellation(ReverseCancellation));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/ReverseCancellation/Modal.jsx